import React from 'react';
import { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import cctv from '../../assets/images/carrousel/cctv.jpg';
import earch from '../../assets/images/carrousel/earch.jpg';
import eb from '../../assets/images/carrousel/eb.jpg';
import groundwater from '../../assets/images/carrousel/groundwater.jpg';
import readytoconstruct from '../../assets/images/carrousel/readytoconstruct.jpg';
import Road from '../../assets/images/carrousel/Road.jpg';
import solar from '../../assets/images/carrousel/solar.jpg';
import trees from '../../assets/images/carrousel/trees.jpg';
import wall from '../../assets/images/carrousel/wall.jpg';

const images = [
  { url: cctv, title: '24 / 7 Security Service' },
  { url: earch, title: 'Grand Entrance arch' },
  { url: eb, title: 'EB Provided' },
  { url: groundwater, title: 'Portable Ground Water' },
  { url: readytoconstruct, title: 'Ready To Construct' },
  { url: Road, title: 'Black Top Roads' },
  { url: solar, title: 'Solar Street Lights' },
  { url: trees, title: 'Avenue Trees' },
  { url: wall, title: 'Fully Compounded Wall' },
];

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 1, // Slide one item at a time
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

const HomeGallery = () => {
  return (
    <section className="home-gallery" >
      <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8 text-center" data-aos="fade-up">
              <h3 className="display-6 fw-bold">Amenities <span className='underline-slide'>That Elevate</span></h3>
            </div>
          </div>
        </div>
    <div style={{ maxWidth: '1200px', margin: '50px auto' }}>
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={3000} // <-- Auto slide every 3 seconds
        keyBoardControl={true}
        containerClass="carousel-container"
        itemClass="carousel-item-padding-40-px"
        removeArrowOnDeviceType={[]} // keeps arrows on all devices
      >
        {images.map((img, index) => (
          <div key={index} style={{ padding: '10px', boxSizing: 'border-box' }}>
            <div style={{
              width: '100%',
              height: '500px',
              position: 'relative',
              borderRadius: '10px',
              overflow: 'hidden',
            }}>
              <img
                src={img.url}
                alt={img.title}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
              <div style={{
                position: 'absolute',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                color: 'white',
                fontSize: '1.2rem',
                textAlign: 'center',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                backgroundColor: 'rgba(0,0,0,0.5)',
                padding: '5px 15px',
                borderRadius: '5px',
              }}>
                {img.title}
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
    </section>
  );
};

export default HomeGallery;
